import dynamic from 'next/dynamic';
export type { AvailableStreamsCarouselProps as AvailableStreamsCarouselType } from './AvailableStreamsCarousel';

// left dynamic since ti refers swiper
// TODO: restore static import once swiper has been removed
export const AvailableStreamsCarousel = dynamic(
  () =>
    import('components/availableStreamsCarousel/AvailableStreamsCarousel').then((mod) => mod.AvailableStreamsCarousel),
  { ssr: false }
);
